var exports = {
  "Ke": "xfd349460--58c7bc--no_image",
  "UT": "xfd349460--58c7bc--no_image--with_text",
  "SB": "xfd349460--58c7bc--no_image-icon",
  "wv": "xfd349460--58c7bc--no_image-text",
};

module.exports = exports;
